module.exports = __webpack_public_path__ + "img/visa.a7a5df69.svg";